<template>
    <div>
        <dynamic-toolbar :title="'FlatRate ID : ' + MainFlat + ' / Trip : ' + Trip" :loading="loading.lists"
            color="indigo" icon="mdi-note-search" theme="dark">
            <template #buttons>
                
                <v-btn outlined class="mr-2" depressed @click="$emit('close')" small dark>
                    <v-icon left>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn color="blue" depressed @click="openNew" small dark>
                    <v-icon left>mdi-plus-circle</v-icon>
                    New
                </v-btn>
            </template>
        </dynamic-toolbar>
        <v-container grid-list-xs fluid>
            <v-data-table :headers="headers" :items="BFH" dense>
                <template v-slot:item.Type="{ item }">
                    <v-combobox v-model="item.Type" :items="types" :item-text="'text'" :item-value="'id'"
                    required dense hide-details @change="updateAmount(item)"></v-combobox>
                </template>
                <template v-slot:item.Amount="{ item }">
                    <v-text-field dense hide-details v-model="item.Amount" @change="updateAmount(item)"></v-text-field>
                </template>
                
                <template v-slot:item.Active="{item}">
                            <v-switch
                            dense
                            hide-details
                            v-model="item.Active"
                            @change="updateAmount(item)"
                            ></v-switch>
                        </template>
                <template v-slot:item.Action="{ item, idx }">
                    <v-btn color="red" @click="dltFBHolds(item, idx)"
                        icon><v-icon>mdi-delete</v-icon></v-btn>
                </template>
            </v-data-table>
        </v-container>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <addNewFB v-if="openAddFB" :openAddFB="openAddFB" :MainFlat="MainFlat" @close="closeNew()"></addNewFB>
    </div>
</template>
<script>
function logErr(error) {
    console.log(error);
}
import DateRangeMenu from './../../Global/Utils/DateRangeMenu.vue';
import DynamicToolbar from './../..//Global/Utils/DynamicToolbar.vue';
import ConfirmDialogue from './../../Modals/ConfirmDialogue.vue';
import addNewFB from './AddNewFBHold.vue';
import axios from 'axios';
export default {
    components: {
        DynamicToolbar,
        DateRangeMenu,
        ConfirmDialogue,
        addNewFB
    },
    props: ['Trip', 'MainFlat','toggle'],
    data: function () {
        return {
            loading: {
                lists: false,
                cost: false,
                dateRangeTotalCost: false,
                totalCostByType: false,
                totalCostByEquipment: false,
                totalCostByCategory: false,
                totalCostBySubcategory: false,
                report: false
            },
            headers: [
                { text: 'FlatRateId', value: 'FlatRateId' },
                { text: 'Trip', value: 'Trip' },
                { text: 'RateId', value: 'RateId' },
                { text: 'Type', value: 'Type' },
                { text: 'Amount', value: 'Amount' },
                {text: 'Active', value: 'Active'},
                { text: 'Action', value: 'Action' },
            ],
            BFH: [],
            types: [
                { id: 1, text: 'FrontHaul' },
                { id: 2, text: 'BackHaul' },
            ],
            openAddFB: false,

        }
    },

    methods: {
        updateAmount: function (itm) {
            var parms = {
                Amount: itm.Amount,
                Type: itm.Type.id,
                Active: itm.Active
            }
            axios
                .put('group-rate-hold/' + itm.GroupingRateId, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                    this.show = true;
                });
        },
        getFBH() {
            this.loading.lists = true;
            axios
                .get('group-rate-hold/all/' + this.MainFlat, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.BFH = response.data;
                    this.BFH.forEach(x => {
                        const idx = this.types.findIndex(y => {
                            return x.Type == y.id; 
                        });
                        console.log(idx);
                        x.Type = this.types[idx];
                    });
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                    this.show = true;
                });
        },
        openNew: function () {
            this.openAddFB = true;
        },
        async dltFBHolds(itm, idx) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this '+ itm.Type +'.',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteFBHolds(itm.GroupingRateId, idx);
            }
        },
        deleteFBHolds: function (id, idx) {
            axios
                .delete('group-rate-hold/' + id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                    this.BFH.splice(idx, 1);
                })
                .catch(error => {
                    this.logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                    this.show = true;
                });
        },
        closeNew: function () {
            this.openAddFB = false;
            this.getFBH();
        },
    },
    mounted() {
        this.getFBH();
    },
}
</script>